export default {
    toggle: function () {
        // toggle styles for mobile nav
        this.element.on('hidden.bs.modal', (e) => {
            this.removeClass('modal-open--mobile-nav');
        }).on('shown.bs.modal', (e) => {
            this.addClass('modal-open--mobile-nav');
        });
    }
}